export const typeValidationVasActionTypes = {
  GET_TYPE_VALIDATION_VAS: 'GET_TYPE_VALIDATION_VAS',
  GET_TYPE_VALIDATION_VAS_EXITO: 'GET_TYPE_VALIDATION_VAS_EXITO',
  GET_TYPE_VALIDATION_VAS_ERRROR: 'GET_TYPE_VALIDATION_VAS_ERRROR'
}
